import React from "react";
import useTranslation, { Translation } from "next-translate/useTranslation";
import { SmilePlusPlan, SmilePlusSubscriptionPlanProductEnum } from "types/User";
import { themeConsts } from "src/utils/theme";
import { SMILE_PLUS_PRICE_YEARLY } from "src/utils/prices";
import { FormatPrice } from "src/utils/formatPrice";
import SmileSharedCustomPlanRadio from "./SmileSharedCustomPlanRadio";

export interface SmileSharedPlanRadioProps {
  plan: SmilePlusPlan;
  formatPrice: FormatPrice;
}

const SmileSharedPlanRadio = ({ plan, formatPrice }: SmileSharedPlanRadioProps) => {
  const { t } = useTranslation();
  return (
    <SmileSharedCustomPlanRadio
      value={formatValue(plan)}
      title={formatTitle(plan, t)}
      priceText={formatPriceText(plan, t, formatPrice)}
      priceSubtext={formatPriceSubtext(plan, t, formatPrice)}
      color={formatColor(plan)}
    />
  );
};

const formatValue = (plan: SmilePlusPlan): string => {
  return plan.plan;
};

const formatTitle = (plan: SmilePlusPlan, t: Translation): string => {
  return t(`smile:smilePlusSignUp_plan${plan.plan}Title`);
};

const formatPriceText = (plan: SmilePlusPlan, t: Translation, formatPrice: FormatPrice): string => {
  let price = plan.price;
  if (plan.plan === SmilePlusSubscriptionPlanProductEnum.SMILE_PLUS_YEARLY) {
    price = price / 12;
  }
  return t(`smile:smilePlusSignUp_plan${plan.plan}Text`, {
    price: formatPrice(price),
  });
};

const formatPriceSubtext = (plan: SmilePlusPlan, t: Translation, formatPrice: FormatPrice): string => {
  if (plan.plan === SmilePlusSubscriptionPlanProductEnum.SMILE_PLUS_YEARLY) {
    return `${t(`smile:smilePlusSignUp_plan${plan.plan}Subtext`)} ${formatPrice(SMILE_PLUS_PRICE_YEARLY)}`;
  }

  return "";
};

const formatColor = (plan: SmilePlusPlan): string => {
  switch (plan.plan) {
    case SmilePlusSubscriptionPlanProductEnum.SMILE_PLUS_TRIAL:
      return themeConsts.pix;
    case SmilePlusSubscriptionPlanProductEnum.SMILE_PLUS_MONTHLY:
      return themeConsts.smile;
    case SmilePlusSubscriptionPlanProductEnum.SMILE_PLUS_YEARLY:
      return themeConsts.lightPurple;
    default:
      return themeConsts.lightGrey;
  }
};

export default SmileSharedPlanRadio;
